<template>
  <div class="mod my-pre-games">
    <div class="mod__hd">
      <img src="../../../../assets/img/base/title-pre-games.png" alt="预赛记录" />
    </div>
    <div v-if="cupList" class="mod_bd">
      <div class="mod__desc ta_center">
        <dl>
          <dd v-if="isAfter(preRes) && preRank && maxAvgScore > 0">你参加的擂台最高平均分<span class="red">{{maxAvgScore}}</span>分，初赛排名<k-txt-rank :value="preRank" /></dd>
          <dd v-else-if="maxAvgScore > 0">你参加的擂台最高平均分<span class="red">{{maxAvgScore}}</span>分</dd>
          <dd>取<span class="red">4</span>个擂台各自的平均分中的<span class="red">最高平均分</span>作为初赛成绩</dd>
        </dl>
      </div>

      <my-pre-cup v-for="(cup, index) in cupList" :key="index" :cup-id="cup.cupId" :oid="index + 1" />
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapGetters
  } from 'vuex'
  import MyPreCup from './pre-cup'
  export default {
    name: 'my-pre-games',
    components: {
      [MyPreCup.name]: MyPreCup
    },
    computed: {
      ...mapState(['cupList']),
      ...mapGetters(['isAfter', 'realityCupId', 'preRes', 'preScore', 'preRank', 'maxAvgScore']),
      ...mapGetters('reality', ['allActions'])
    },
    async created() {

      // console.log(JSON.stringify(games));
    }
  };

</script>
